import { useTheme } from '@mui/material/styles'
import PropTypes from 'prop-types'
import CartIcon from '@/assets/templates/icons/cartIcon'

const TemplateNavigation = ({
  textColor,
  backgroundColor,
  children,
  hasShoppingCart,
  ...rest
}) => {
  const theme = useTheme()

  // Direct mapping from provided theme:
  const paletteMapping = {
    primary: theme.palette.primary.main, // PRIMARY
    secondary: theme.palette.secondary.main, // SECONDARY
    textPrimary: theme.palette.text.primary, // TEXT
    textSecondary: theme.palette.text.secondary, // LIGHT TEXT
    complementary: theme.palette.background.paper, // COMPLEMENTARY
  }

  const navTextColor = paletteMapping[textColor] ?? textColor ?? theme.palette.text.primary

  const navBackgroundColor = paletteMapping[backgroundColor] ?? backgroundColor ?? 'transparent'

  return (
    <nav
      {...rest}
      style={{
        backgroundColor: navBackgroundColor,
        color: navTextColor,
        fill: navTextColor,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {children}
      {hasShoppingCart && <CartIcon />}
    </nav>
  )
}

TemplateNavigation.propTypes = {
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  hasShoppingCart: PropTypes.bool
}

export default TemplateNavigation
